const $ = jQuery.noConflict();

const headerColor = () => {
	// Cache DOM
	const $window = $(window);
	const $document = $(document);
	const header = $('header.header');
	const logo = header.find('.header__logo');
	const menuBtn = header.find('.header__menu-btn');
	const sections = $('.section');

	// Functions
	function checkActiveSection() {
		const scrollPosition = $document.scrollTop();
		const headerHeight = header.outerHeight();
		let activeSection = '';
		let activeSectionColor = '';

		sections.each(function () {
			if ($(this).position().top <= (scrollPosition + (headerHeight / 2))) {
				activeSectionColor = $(this).data('headerColor');
				activeSection = $(this);
			}
		});

		if ($window.width() < 992 && activeSection.position().top > 0) {
			header.addClass('header--mobile-bg');
		} else {
			header.removeClass('header--mobile-bg');
		}

		if (activeSectionColor === 'white') {
			if ($window.width() < 992 && activeSection.position().top > 0) {
				logo.removeClass('header__logo--white');
				menuBtn.addClass('color-btn');
			} else {
				logo.addClass('header__logo--white');
				menuBtn.removeClass('color-btn');
			}
		} else {
			logo.removeClass('header__logo--white');
			menuBtn.addClass('color-btn');
		}
	}

	// Bind events
	checkActiveSection();
	$window.on('resize scroll', checkActiveSection);
};

export default headerColor;
